import { fetchBulkIssues } from '@atlassian/jira-issue-view-services/src/issue/issues-bulk-fetch-server.tsx';
import type { BaseUrl, IssueKey } from '@atlassian/jira-shared-types/src/general.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (baseUrl: BaseUrl, issueKeys: IssueKey[]) =>
	fetchBulkIssues(baseUrl, issueKeys, ['assignee']).toPromise();
